/**
 * 書類（見積書・請求書）公開ビュー用のカテゴリーロゴヘッダ。
 *
 * Deal の primaryCategoryId に紐づく ProductCategory.logoStoragePath を表示する。
 * position プリセット (top-left / top-center / top-right) で配置を切り替える。
 */
import type { CategoryLogoPosition } from '@goenhub/shared';

interface Props {
  logo: {
    url: string;
    position: CategoryLogoPosition;
  } | null;
}

const POSITION_TO_CLASS: Record<CategoryLogoPosition, string> = {
  'top-left': 'justify-start',
  'top-center': 'justify-center',
  'top-right': 'justify-end',
};

export function CategoryLogoHeader({ logo }: Props) {
  if (!logo) return null;
  return (
    <div className={`flex ${POSITION_TO_CLASS[logo.position]} mb-3 print:mb-2`}>
      <img
        src={logo.url}
        alt=""
        className="max-h-16 max-w-[40%] object-contain"
      />
    </div>
  );
}
